// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Contas_DashboardStatsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /contas/contas/dashboard_stats
 *
 * Aggregate KPI shape — `dados` is a flat object with the four counters.
 * Built by Contas_model::dashboard_stats(); each field maps 1:1 to the
 * SELECT columns there.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Contas_DashboardStatsResponseDados {
total_active_accounts: number
accounts_needing_attention: number
total_received_this_month: number
total_transactions_this_month: number
}

export type Contas_DashboardStatsResponse = ApiResponse<Contas_DashboardStatsResponseDados>;

registerResponseContract('Contas_DashboardStatsResponse', {
  total_active_accounts:         { type: 'number',  required: true },
  accounts_needing_attention:    { type: 'number',  required: true },
  total_received_this_month:     { type: 'number',  required: true },
  total_transactions_this_month: { type: 'number',  required: true },
})
